export default __webpack_public_path__ + "static/media/es.6027bab7.svg";